<h1 id="error">Errore</h1>
<h3 class="mb-4">Caricamento della pagina fallito</h3>

<p>Si è verificato un errore durante il caricamento della pagina, si prega di riprovare più tardi.</p>
